jQuery(document).ready(function ($) {
  $(".option-wrapper").click(function(event){
    //$('.option-wrapper').find("input").attr('checked', false);
    //$(this).find("input").attr('checked', true);
     //$('.product-form__buttons .product-form__submit').removeAttr('disabled'); // Element(s) are now enabled.
  });
  //$('.main-2 .option-wrapper.monthly-delivery label').click();
  $(".option-wrapper").click(function(){
    var sellPlan = $(this).find("input").attr('selling_plan');
    console.log("selected sellPlan:"+sellPlan);
    $("#sellingPlan_ID").val(sellPlan);
  });
  setTimeout(function () {
    /* click of label makes a scrollto effect on the buy block. change this function to change value or id instead */
      //$(".monthly-delivery.active label").click();
    }, 500);

  $('.about-faq .faq-question_LxM34a .accordion').click();
}); 